import {
    ADMIN_LOGGED_IN, ADMIN_LOGIN, ADMIN_LOGOUT, API_CALL_FAILED, SAVE_CUSTOMER, RETRIEVED_CUSTOMERS,
    GET_CUSTOMERS, GET_CUSTOMER, RETRIEVED_CUSTOMER, SAVED_CUSTOMER, PRIVATE_CORE_LOGIN, PRIVATE_CORE_LOGOUT,
    PRIVATE_CORE_LOGGED_IN,
    GET_PREDEFINED_TEXTS, RETRIEVED_PREDEFINED_TEXTS, GET_PROPERTY_DEFINITIONS, RETRIEVED_PROPERTY_DEFINITIONS,
    SAVE_PREDEFINED_TEXT, SAVED_PREDEFINED_TEXT, IMPORTED_PREDEFINED_TEXTS, STARTED_TRANSACTION_IMPORT,
    TRANSACTION_IMPORTED, STARTED_VALUATION_IMPORT, VALUATION_IMPORTED, GET_LANGUAGES, RETRIEVED_LANGUAGES,
    SAVE_LANGUAGE, SAVED_LANGUAGE, RETRIEVED_LANGUAGE, GET_LANGUAGE, SAVE_TRANSLATION_KEYS, SAVED_TRANSLATION_KEYS,
    DOWNLOAD_TRANSLATIONS, DOWNLOADED_TRANSLATIONS
} from "./action-types";

export const adminLogin = data => ({ type: ADMIN_LOGIN, payload: data });
export const adminLogout = (displayError = false) => ({ type: ADMIN_LOGOUT, payload: {displayError} });
export const adminLoggedIn = data => ({ type: ADMIN_LOGGED_IN, payload: data });
export const apiCallFailed = data => ({ type: API_CALL_FAILED, payload: data });

export const getCustomers = () => ({ type: GET_CUSTOMERS, payload: {} });
export const retrievedCustomers = data => ({ type: RETRIEVED_CUSTOMERS, payload: data });
export const getCustomer = id => ({ type: GET_CUSTOMER, payload: {id: id} });
export const retrievedCustomer = data => ({ type: RETRIEVED_CUSTOMER, payload: data });
export const saveCustomer = data => ({ type: SAVE_CUSTOMER, payload: data });
export const savedCustomer = data => ({ type: SAVED_CUSTOMER, payload: data });

export const getLanguages = () => ({ type: GET_LANGUAGES, payload: {} });
export const retrievedLanguages = data => ({ type: RETRIEVED_LANGUAGES, payload: data });
export const getLanguage = id => ({ type: GET_LANGUAGE, payload: {id:id} });
export const retrievedLanguage = data => ({ type: RETRIEVED_LANGUAGE, payload: data });
export const downloadTranslations = (id, format, flat) => ({ type: DOWNLOAD_TRANSLATIONS, payload: {id, format, flat} });
export const downloadedTranslations = (id, format, flat, translations, metaData) => ({ type: DOWNLOADED_TRANSLATIONS, payload: {id, format, flat, translations, metaData} });
export const saveLanguage = data => ({ type: SAVE_LANGUAGE, payload: data });
export const savedLanguage = data => ({ type: SAVED_LANGUAGE, payload: data });
export const saveTranslationKeys = data => ({ type: SAVE_TRANSLATION_KEYS, payload: data });
export const savedTranslationKeys = data => ({ type: SAVED_TRANSLATION_KEYS, payload: data });

export const privateCoreLogin = credentials => ({ type: PRIVATE_CORE_LOGIN, payload: credentials });
export const privateCoreLogout = () => ({ type: PRIVATE_CORE_LOGOUT, payload: {} });
export const privateCoreLoggedIn = customerAndJwt => ({ type: PRIVATE_CORE_LOGGED_IN, payload: customerAndJwt });

export const getPredefinedTexts = data => ({ type: GET_PREDEFINED_TEXTS, payload: data });
export const retrievedPredefinedTexts = data => ({ type: RETRIEVED_PREDEFINED_TEXTS, payload: data });
export const savePredefinedText = data => ({ type: SAVE_PREDEFINED_TEXT, payload: data });
export const savedPredefinedText = data => ({ type: SAVED_PREDEFINED_TEXT, payload: data });
export const importedPredefinedTexts = data => ({ type: IMPORTED_PREDEFINED_TEXTS, payload: data });

export const getPropertyDefinitions = data => ({ type: GET_PROPERTY_DEFINITIONS, payload: data });
export const retrievedPropertyDefinitions = data => ({ type: RETRIEVED_PROPERTY_DEFINITIONS, payload: data });

export const startedTransactionImport = data => ({ type: STARTED_TRANSACTION_IMPORT, payload: data });
export const transactionImported = data => ({ type: TRANSACTION_IMPORTED, payload: data });

export const startedValuationImport = data => ({ type: STARTED_VALUATION_IMPORT, payload: data });
export const valuationImported = data => ({ type: VALUATION_IMPORTED, payload: data });



// WEBPACK FOOTER //
// ./src/redux/actions.js